// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LEwcXMBe4ZMh7l6FN76Q,.NhJ3xDR6OYw0dQhFDiRD{margin:4px auto 4px 8px}.nke1kqjNK2kF1GzscuDJ{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"importAllTeamsButton": `LEwcXMBe4ZMh7l6FN76Q`,
	"refreshDataButton": `NhJ3xDR6OYw0dQhFDiRD`,
	"triggerButtonNowrap": `nke1kqjNK2kF1GzscuDJ`
};
export default ___CSS_LOADER_EXPORT___;
